import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, withKeys as _withKeys, createBlock as _createBlock, Teleport as _Teleport } from "vue";
import _imports_0 from '@/assets/images/pc.png';
import _imports_1 from '@/assets/images/mobile.png';
const _hoisted_1 = {
  class: "keyword-report p-2"
};
const _hoisted_2 = {
  key: 0,
  class: "text-base font-medium flex items-center"
};
const _hoisted_3 = {
  class: "tab-block mt-3"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "content"
};
const _hoisted_6 = {
  class: "img-box mr-1"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "flex-1"
};
const _hoisted_9 = {
  class: "label text-sm"
};
const _hoisted_10 = {
  class: "value text-sm"
};
const _hoisted_11 = {
  key: 0,
  class: "icon"
};
const _hoisted_12 = {
  key: 0,
  src: _imports_0
};
const _hoisted_13 = {
  key: 1,
  src: _imports_1
};
const _hoisted_14 = {
  key: 0,
  class: "text-base font-medium"
};
const _hoisted_15 = {
  class: "search-block flex items-center mt-4 gap-4"
};
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = {
  class: "table-block mt-4 flex-1 overflow-hidden relative"
};
const _hoisted_18 = {
  key: 1,
  class: "flex justify-center mt-6"
};
const _hoisted_19 = {
  key: 1,
  class: "text-sm text-gray-400"
};
const _hoisted_20 = {
  key: 2,
  class: "flex justify-end mt-6"
};
import { set } from 'lodash-es';
import { ref, onMounted, computed, reactive, watch, nextTick } from 'vue';
import useAppStore from '@views/app.store';
import { Search } from '@element-plus/icons-vue';
import useMainStore from '@views/main/main.store';
import { getModelName } from '@views/main/config';
import { getSingleByMode } from '@views/main/pages/view-effect/config.js';
import { assessEffectSummary, assessEffectListV2, keywordSummary, keywordEffectList } from '@views/main/api';
import { generateUk } from '@/views/home/api';
export default /*@__PURE__*/_defineComponent({
  __name: 'KeywordReport',
  props: {
    item: {},
    content: {},
    isSummary: {
      type: Boolean
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const props = __props;
    const appStore = useAppStore();
    const mainStore = useMainStore();
    const info = ref({
      includeDate: ''
    });
    const tabList = ref([]);
    const tableData = ref([]);
    const hasMore = ref(false);
    const isFirstLoad = ref(true);
    const loading = ref(false);
    const total = ref(0);
    const activeTab = ref('');
    const showPreview = ref(false);
    const previewIns = ref(0);
    const searchParams = reactive({
      model: '',
      type: '',
      keyword: '',
      pageNum: 1,
      pageSize: 10,
      snapshotId: null,
      lastId: null,
      dateRange: [null, null]
    });
    watch(() => appStore.geoMode, async geoMode => {
      await nextTick();
      tabList.value = getSingleByMode(geoMode);
      getTotalData();
    }, {
      immediate: true
    });
    const showTabList = computed(() => {
      return tabList.value.filter(item => item.isShow);
    });
    const previewUrlArr = computed(() => tableData.value.map(item => item.remotePath));
    const resetCursor = () => {
      searchParams.snapshotId = null;
      searchParams.lastId = null;
      searchParams.pageNum = 1;
      hasMore.value = false;
      total.value = 0;
      isFirstLoad.value = true;
      tableData.value = [];
    };
    const getTotalData = async () => {
      let data = null;
      if (props.isSummary) {
        const ret = await keywordSummary({});
        data = ret.data;
        data.details = data.effects;
      } else {
        const ret = await assessEffectSummary({
          sessionId: mainStore.msgParams.sessionId
        });
        data = ret.data;
      }
      // const { data } = await assessEffectSummary({
      //   sessionId: mainStore.msgParams.sessionId,
      // })
      if (data?.details) {
        tabList.value.forEach(tabItem => set(tabItem, 'isShow', false));
        data.details.forEach(item => {
          const tabItemArr = tabList.value.filter(tabItem => tabItem.model === item.model);
          tabItemArr.forEach(tabItem => {
            if (tabItem.isPc) {
              set(tabItem, 'totalCount', item.webTotal || 0);
            } else {
              set(tabItem, 'totalCount', item.mobileTotal || 0);
            }
            set(tabItem, 'isShow', true);
          });
        });
        tabList.value[0].isShow = true;
        tabList.value[0].totalCount = data.total;
      }
    };
    const getListData = async () => {
      try {
        loading.value = true;
        if (!searchParams.dateRange) {
          searchParams.dateRange = ['', ''];
        }
        const baseParams = {
          sessionId: mainStore.msgParams.sessionId,
          model: searchParams.model,
          type: searchParams.type,
          keyword: searchParams.keyword,
          reportDate: props.isSummary ? '' : info.value.includeDate,
          pageSize: searchParams.pageSize,
          startDate: searchParams.dateRange[0] ? `${searchParams.dateRange[0]} 00:00:00` : '',
          endDate: searchParams.dateRange[1] ? `${searchParams.dateRange[1]} 23:59:59` : ''
        };
        if (props.isSummary) {
          // /home/statistical/data 关键词报表：V1 分页接口（pageNum / total）
          const {
            data
          } = await keywordEffectList({
            ...baseParams,
            pageNum: searchParams.pageNum
          });
          tableData.value = data?.list || [];
          total.value = parseInt(data?.total || '0', 10);
        } else {
          // 会话内效果列表：V2 游标分页（加载更多）
          const params = {
            ...baseParams
          };
          if (isFirstLoad.value) {
            delete params.snapshotId;
            delete params.lastId;
          } else {
            params.snapshotId = searchParams.snapshotId;
            params.lastId = searchParams.lastId;
          }
          // 捕获请求时刻的 isFirstLoad，避免 await 期间 filter 切换造成游标串扰
          const isFirst = isFirstLoad.value;
          const {
            data
          } = await assessEffectListV2(params);
          // 如果等待响应期间已重置游标（filter 已切换），丢弃该响应
          if (isFirst !== isFirstLoad.value) return;
          const list = data?.list || [];
          if (isFirst) {
            tableData.value = list;
            isFirstLoad.value = false;
          } else {
            tableData.value = tableData.value.concat(list);
          }
          // 字符串字段原样保留，不做 Number() 转换
          searchParams.snapshotId = data?.snapshotId ?? null;
          searchParams.lastId = data?.lastId ?? null;
          hasMore.value = !!data?.hasMore;
        }
      } finally {
        loading.value = false;
      }
    };
    const loadMore = () => {
      if (props.isSummary) return;
      if (!hasMore.value || loading.value) return;
      getListData();
    };
    // V1 分页翻页（/home/statistical/data 关键词报表）
    const handlePageChange = currentPage => {
      searchParams.pageNum = currentPage;
      getListData();
    };
    const handleView = (row, index) => {
      previewIns.value = index;
      showPreview.value = true;
    };
    // 筛选条件变化时触发：重置游标后重新请求首页
    const handleSearch = () => {
      resetCursor();
      getListData();
    };
    const handleClick = item => {
      activeTab.value = item.value;
      searchParams.model = item.model;
      if (item.model) {
        searchParams.type = item.isPc ? 2 : 1;
      } else {
        searchParams.type = '';
      }
      handleSearch();
    };
    const uk = ref('');
    async function getUk() {
      const {
        data
      } = await generateUk({});
      uk.value = data.uk;
    }
    async function handleClickReport() {
      window.open(`/view-effect?uk=${uk.value}`);
    }
    onMounted(() => {
      try {
        if (!props.isSummary) {
          info.value = props.content;
        } else {
          getUk();
        }
        // getTotalData()
        getListData();
      } catch (e) {
        console.log(e);
      }
    });
    __expose({
      handleClick
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_cus_tip = _resolveComponent("cus-tip");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_image_viewer = _resolveComponent("el-image-viewer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass({
          'isSummary': props.isSummary,
          'mb-4': props.isSummary
        })
      }, [props.isSummary ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_cache[4] || (_cache[4] = _createElementVNode("span", null, "关键词报表", -1)), _createVNode(_component_el_button, {
        type: "text",
        class: "text-xs ml-2",
        onClick: handleClickReport
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode(" 查看上词数据 ", -1)]))]),
        _: 1
      })])) : _createCommentVNode("", true), _createElementVNode("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showTabList.value, item => {
        return _openBlock(), _createElementBlock("li", {
          key: item.value,
          class: _normalizeClass(["tab-item", {
            active: item.value === activeTab.value
          }]),
          onClick: $event => handleClick(item)
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
          src: item.icon,
          alt: ""
        }, null, 8, _hoisted_7)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(item.label), 1), _createElementVNode("span", _hoisted_10, _toDisplayString(item.totalCount), 1)]), props.isSummary ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [item.value ? (_openBlock(), _createElementBlock("div", _hoisted_11, [item.isPc ? (_openBlock(), _createElementBlock("img", _hoisted_12)) : (_openBlock(), _createElementBlock("img", _hoisted_13))])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [item.value ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["icon", {
            'is-pc': item.isPc
          }])
        }, _toDisplayString(item.isPc ? '电脑端' : '手机端'), 3)) : _createCommentVNode("", true)], 64))])], 10, _hoisted_4);
      }), 128))])], 2), _createElementVNode("div", {
        class: _normalizeClass({
          isSummary: props.isSummary
        })
      }, [props.isSummary ? (_openBlock(), _createElementBlock("div", _hoisted_14, "关键词列表")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_input, {
        modelValue: searchParams.keyword,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchParams.keyword = $event),
        style: {
          "width": "240px"
        },
        placeholder: "请输入关键词",
        "prefix-icon": _unref(Search),
        clearable: "",
        onKeypress: _withKeys(handleSearch, ["enter"])
      }, null, 8, ["modelValue", "prefix-icon"]), props.isSummary ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_el_date_picker, {
        modelValue: searchParams.dateRange,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchParams.dateRange = $event),
        type: "daterange",
        "range-separator": "至",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期",
        format: "YYYY-MM-DD",
        "value-format": "YYYY-MM-DD",
        class: "el-date-editor--small",
        onChange: handleSearch
      }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
        type: "primary",
        class: "search-btn w-[68px]",
        loading: loading.value,
        onClick: handleSearch
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" 查询 ", -1)]))]),
        _: 1
      }, 8, ["loading"])]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_el_table, {
        data: tableData.value,
        height: "460px",
        "tooltip-options": {
          popperClass: 'tooltip-w tooltip'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "index",
          label: "序号",
          width: "80",
          align: "center"
        }), props.isSummary ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 0,
          prop: "taskName",
          label: "任务名称",
          "max-width": "140"
        }, {
          default: _withCtx(scope => [_createVNode(_component_cus_tip, {
            content: scope.row.taskName
          }, null, 8, ["content"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
          prop: "brand",
          label: "命中品牌词"
        }, {
          default: _withCtx(scope => [_createVNode(_component_cus_tip, {
            content: scope.row.brand
          }, null, 8, ["content"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "keyword",
          label: "问题"
        }, {
          default: _withCtx(scope => [_createVNode(_component_cus_tip, {
            content: scope.row.keyword
          }, null, 8, ["content"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "model",
          label: "平台",
          align: "center"
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(_unref(getModelName)(scope.row.model)?.label || '--'), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "type",
          label: "终端",
          align: "center"
        }, {
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(row.type === 1 ? '移动端' : '电脑端'), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "创建时间",
          "min-width": "120"
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row,
            $index
          }) => [_createVNode(_component_el_button, {
            type: "text",
            size: "mini",
            onClick: $event => handleView(row, $index)
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" 查看截图 ", -1)]))]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]), !props.isSummary ? (_openBlock(), _createElementBlock("div", _hoisted_18, [hasMore.value ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        loading: loading.value,
        type: "primary",
        plain: "",
        onClick: loadMore
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" 加载更多 ", -1)]))]),
        _: 1
      }, 8, ["loading"])) : tableData.value.length ? (_openBlock(), _createElementBlock("span", _hoisted_19, "已加载全部")) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_component_el_pagination, {
        background: "",
        layout: "prev, pager, next",
        total: total.value,
        "current-page": searchParams.pageNum,
        onCurrentChange: handlePageChange
      }, null, 8, ["total", "current-page"])]))], 2), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [showPreview.value ? (_openBlock(), _createBlock(_component_el_image_viewer, {
        key: 0,
        "url-list": previewUrlArr.value,
        "show-progress": "",
        "initial-index": previewIns.value,
        onClose: _cache[2] || (_cache[2] = $event => showPreview.value = false)
      }, null, 8, ["url-list", "initial-index"])) : _createCommentVNode("", true)]))]);
    };
  }
});